/* global reelPlaylist */
/* eslint no-underscore-dangle: ["error", { "allow": ["playlistItemId_"] }] */

import 'videojs-playlist';
import videojs from 'video.js';

const reel = {
  player: '',
  clip: document.getElementById('video'),
  title: document.querySelector('.js-reel-title'),
  links: [...document.getElementsByClassName('js-reel-link')],
  activeTitleIndex: '',
};

const titleEnter = (index) => {
  // Animate in and set active index
  reel.activeTitleIndex = index - 1;
  reel.links[reel.activeTitleIndex].classList.toggle('js-reel-link--active');
};

const titleExit = (index) => {
  // Animate out
  reel.links[reel.activeTitleIndex].classList.toggle('js-reel-link--exit');

  // Reset after animation
  const delay = setTimeout(() => {
    reel.links[reel.activeTitleIndex].classList.toggle('js-reel-link--active');
    reel.links[reel.activeTitleIndex].classList.toggle('js-reel-link--exit');
    titleEnter(index);
    clearTimeout(delay);
  }, 1500);
};

const switchTitle = (index) => {
  // First loop active isn't set so skip
  if (reel.activeTitleIndex !== '') {
    titleExit(index);
  } else {
    titleEnter(index);
  }
};

if (reel.clip) {
  // Add video js to reel var
  reel.player = videojs('video');
}

if (typeof reelPlaylist !== 'undefined') {
  if (reelPlaylist.length > 1) {
    // Init playlist.
    reel.player.playlist(reelPlaylist);

    // Play through the playlist automatically.
    reel.player.playlist.autoadvance(0);

    // Jump back to the beginning.
    reel.player.playlist.repeat(true);

    // Bring in the title
    reel.title.classList.add('js-reel-title--active');

    // Change event checks and actions.
    reel.player.on('playlistitem', (e, i) => {
      switchTitle(i.playlistItemId_);
    });
  } else {
    // One item in reel loop that item.
    reel.player.poster(reelPlaylist[0].poster);
    reel.player.src(reelPlaylist[0].sources[0]);
    reel.player.loop(true);

    // Bring in the title
    reel.title.classList.add('js-reel-title--active');

    // Bring in the link
    switchTitle(1);
  }
}
